import { render, staticRenderFns } from "./StarredQuestion.vue?vue&type=template&id=28507530&scoped=true&"
import script from "./StarredQuestion.vue?vue&type=script&lang=ts&"
export * from "./StarredQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=28507530&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28507530",
  null
  
)

export default component.exports